<template>
<app-slide>
    <article class="layout" id="start">
        <div v-if="contentLoaded" class="container">
          <div class="row">
              <div class="col-xs-12 text-content">
                  <h2 class="margin-bottom-2">{{venue.title}}</h2>
                  <p v-if="!isInFavs" @click="addVenue(venue)">{{getTranslation('save-this-venue')}}</p>
                  <p v-if="isInFavs" @click="removeVenue(venue)">{{getTranslation('remove-from-saved')}}</p>
              </div>
              <div class="col-xs-12">
                <dl v-if="venue.address">
                  <dt>{{getTranslation('address')}}</dt>
                  <dd>{{venue.address}}</dd>
                </dl>
                <dl v-if="venue.city">
                  <dt>{{getTranslation('city')}}</dt>
                  <dd>{{venue.city}}</dd>
                </dl>
                <!-- <dl v-if="venue.city">
                  <dt>Category</dt>
                  <dd>{{venue.category}}</dd>
                </dl> -->
            </div>
                  <div class="col-xs-12 margin-bottom-2">
                    <dl v-if="venue.hours">
                      <dt>{{getTranslation('hours')}}</dt>
                      <dd v-html="venue.hours"></dd>
                    </dl>
                    <dl v-if="venue.closed">
                      <dt>{{getTranslation('closed')}}</dt>
                      <dd v-html="venue.closed"></dd>
                    </dl>
                    <dl v-if="venue.website">
                      <dt>{{getTranslation('website')}}</dt>
                      <dd>{{venue.website}}</dd>
                    </dl>
                    <dl v-if="venue.phone">
                      <dt>{{getTranslation('phone')}}</dt>
                      <dd>{{venue.phone}}</dd>
                    </dl>
                  </div>
                  <div class="col-xs-12 margin-bottom-1">
                      <img :src="venue.image" class="img-responsive" :alt="venue.title"/>
                  </div>
                  <div class="col-xs-12 margin-top-2 margin-bottom-2 text-content" v-if="venue.body" v-html="venue.body"></div>
                  <div class="col-xs-12">
                     <map-venue v-if="mapReady" :position="venue.position" class="map-artwork"></map-venue>
                  </div>
                  <div class="col-xs-12 margin-bottom-1">
                    <h2 class="margin-top-4 margin-bottom-2">{{getTranslation('distance-to-next-venue')}}</h2>
                     <table class="table-styles" cellPadding="0" cellSpacing="0">
                        <tr>
                          <th colspan="2"></th>
                          <th>{{getTranslation('by-foot')}}</th> 
                          <th>{{getTranslation('by-car')}}</th>
                        </tr>
                        <tr v-for="(row) in venue.distances" :key="row.letter">
                          <td class="roman">{{row.letter}}</td>
                          <td>{{row.venue}}</td>
                          <td>{{row.foot}}</td>
                          <td>{{row.car}}</td>
                        </tr>
                      </table>
                  </div>
                  <div class="col-xs-12 margin-bottom-1">
                      <h2 class="margin-top-4 margin-bottom-2">{{getTranslation('artworks')}}</h2>
                      <table class="table-styles" cellPadding="0" cellSpacing="0">
                        
                        <router-link tag="tr" :to="getWorkUrl(item)" v-for="item in orderBy(venue.artworks, 'artistCode')" :key="item.id">
                          <td class="border-bottom">
                            <p class="roman no-margin">{{item.title}}</p>
                            <p class="no-margin">{{item.artist}}</p>  
                          </td>
                          <td class="border-bottom">
                            <p class="text-right">{{item.artistCode}}.{{item.code}}</p>
                          </td>
                        </router-link>
                      </table>
                  </div>
              </div>
          </div>
    </article>
    </app-slide>
</template>


<script>
  import {store} from '../store/store'
  import appSlide from '../transitions/AppSlide'
  import mapVenue from '../components/MapVenue'
  import mixinLanguages from '../mixins/Language'
  // import slide from '../mixins/PageSlide'
  export default {
    name: 'venueDetail',
    components: {
      appSlide,
      mapVenue
    },
    props: ['slug'],
    mixins: [mixinLanguages],
    data() {
      return {
        venue:'',
        mapReady:false,
        contentLoaded:false
      }
    },
    mounted () {
      this.getVenue();
      let thisUrl = '99/' + this.slug;
      store.dispatch('setDestUrl', thisUrl);
      store.dispatch('setDestChange', false);
    },
    computed:{
      lang() { 
        return this.$store.state.langUrl;
      },
      isInFavs() {
        let vm = this;
        let compareList = this.$store.getters.getFavVenues.filter(function (item) {
          return item.code.match(vm.venue.code);
        });
        if (compareList.length) {
          return true;
        } else {
          return false;
        }
      },
    },
    watch: {
      // use the watch to react on the value change.
      lang(newValue) {
        this.getVenue();
      }
    },
    methods: {
      getVenue () {
        let baseUrl = this.$store.getters.getBaseUrl;
        let lang = this.$store.getters.getLangState;
        let url = baseUrl + lang + '/api/mobile/v1/venues/' + this.slug + '.json';
        this.$http.get(url).then((response) => {
          this.venue = response.data.data[0];
          this.mapReady = true;
          this.contentLoaded = true;
        })
      },
      getWorkUrl(item) {
        return '/' + item.artistCode + '/' + item.code;
        // return '/' + item.artistCode + '/00';
      },
      addVenue(obj) {
        store.commit('addFavVenues', obj);
        // store.commit('addFavArtists', {title:'Alex',id:1});
      },
      removeVenue(obj) {
        let index = this.$store.getters.getFavVenues.findIndex(p => p.code == obj.code);
        store.commit('removeFavVenues', index);
      },
    }
  }
</script>

<style lang="scss">
  
</style>



// WEBPACK FOOTER //
// src/views/VenueDetail.vue